import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Floating kids-mode overlay: colorful bubbles, clouds, stars, rainbows drifting slowly.
 * Sits fixed behind content, non-interactive, respects reduced motion.
 */
export default function KidsSkyOverlay() {
  const reduced = useReducedMotion();

  const items = useMemo(() => {
    const emojis = ["🎈", "☁️", "⭐", "✨", "🌈", "🎀", "🦋", "🌸", "🍬", "💫"];
    return Array.from({ length: 18 }).map((_, i) => ({
      id: i,
      left: `${(i * 53) % 100}%`,
      top: `${(i * 37) % 100}%`,
      size: 18 + ((i * 7) % 26),
      emoji: emojis[i % emojis.length],
      dur: 10 + ((i * 3) % 12),
      delay: (i % 6) * 0.9,
      drift: 20 + ((i * 5) % 40),
    }));
  }, []);

  if (reduced) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[5] overflow-hidden" aria-hidden="true">
      {items.map((it) => (
        <motion.span
          key={it.id}
          className="absolute select-none"
          style={{ left: it.left, top: it.top, fontSize: it.size, opacity: 0.55 }}
          animate={{
            y: [0, -it.drift, 0, it.drift, 0],
            x: [0, it.drift / 2, 0, -it.drift / 2, 0],
            rotate: [-8, 8, -4, 6, -8],
          }}
          transition={{
            duration: it.dur,
            delay: it.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          {it.emoji}
        </motion.span>
      ))}
    </div>
  );
}
